import SubProcessTreeGroup from './SubProcessTreeGroup';
import BausteinTreeGroup from './BausteinTreeGroup';

const VERY_LOW_PRIORITY = 100;

/**
 * Custom properties provider that adds a "Sub-Prozesse" tree group
 * to the properties panel when the diagram contains collapsed sub-processes,
 * and a "Bausteine" group when the file contains reusable processes.
 */
export default class SubProcessTreeProvider {
  constructor(propertiesPanel, injector) {
    propertiesPanel.registerProvider(VERY_LOW_PRIORITY, this);
    this._injector = injector;
  }

  getGroups(element) {
    return (groups) => {
      const treeGroup = SubProcessTreeGroup(element, this._injector);

      if (treeGroup) {
        groups.push(treeGroup);
      }

      // Bausteine liegen in eigenen Diagrammen und tauchen im Sub-Prozess-Baum
      // nicht auf — sie brauchen ein eigenes Verzeichnis.
      const bausteinGroup = BausteinTreeGroup(element, this._injector);

      if (bausteinGroup) {
        groups.push(bausteinGroup);
      }

      return groups;
    };
  }
}

SubProcessTreeProvider.$inject = ['propertiesPanel', 'injector'];
